
import Vue from 'vue'
import App from './App.vue'

//引入Element-ui
import ElementUI from 'element-ui'
Vue.use(ElementUI)

//引入md5 加密
import md5 from 'js-md5';

import 'element-ui/lib/theme-chalk/index.css'
//引入axios
import axios from 'axios'
axios.interceptors.request.use(
  config => {
    const token = window.sessionStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug

    Promise.reject(error)
  }
)

Vue.prototype.$md5 = md5;
Vue.prototype.$dateFormat = require('dateformat')
Vue.prototype.$axios = axios;
import './assets/base.css'//公共css样式

//引入自定义router文件
import router from './router/router' //引入路由文件

// const cors = require('koa2-cors');
//  app.use(cors());

new Vue({
    el: '#app',
    render: h => h(App),
    router
  })
